import Vue from 'vue';

export default new Vue({
  data() {
    return {
      userId: null,
      data: null,
    };
  },
  methods: {
    setUser(user) {
      if (!user) {
        this.userId = null;
        this.data = null;

        return;
      }

      const {
        id,
        _pastEvents,
        _pastMoments,
        _presentEvents,
        _presentMoments,
        _futureEvents,
        _presentEventType,
        location,
      } = user;
      const past = [..._pastMoments, ..._pastEvents];
      const present = [..._presentMoments, ..._presentEvents];
      const future = _futureEvents;

      this.userId = id;
      this.data = { past, present, future, location, _presentEventType };
    },
  },
});
